@if (evaluation?.hasConfirmationTitle) {
  <div class="title-container" fxLayout fxLayoutAlign="center center">
    <h1>{{ evaluation.form.confirmationTitle }}</h1>
  </div>
}
<div fxLayout="column" fxLayoutAlign="start center" class="message">
  <p
    [innerHTML]="
      evaluation?.hasConfirmation
        ? (evaluation.confirmation | safeHtml)
        : 'Thank you for completing the evaluation.'
    "
  ></p>
</div>
